import { useAppSelector } from "@app/hooks";
import { selectApplicationToken, selectRefreshToken, selectUserId } from "@app/data/appTokensStore";
import  {z} from "zod"
import { Credentials } from "@utils/useCredentials/types";
const CredentialsSchema = z.object({
  userId: z.string().min(1).or(z.number().gte(0)),
  jwtToken: z.string(),
  refreshToken: z.string(),
})

const useCredentials = (): Credentials => {
  const userId = useAppSelector(selectUserId)
  const jwtToken = useAppSelector(selectApplicationToken)
  const refreshToken = useAppSelector(selectRefreshToken)
  const result = CredentialsSchema.safeParse({userId, jwtToken, refreshToken})
  if (result.success) {
    return {
      isAuthenticated: true,
      userId: result.data.userId,
      jwtToken: result.data.jwtToken,
      refreshToken: result.data.refreshToken,
    }
  }else{
    return  {
      isAuthenticated: false
    }
  }

}

export default useCredentials